exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header.scrollup[data-v-11080996] {\n  transform: translateY(-36px);\n}\nheader.scrollup .usp-bar .row > div[data-v-11080996] {\n  opacity: 0;\n}\n@media screen and (max-width: 768px) {\nheader .logo[data-v-11080996] {\n    width: auto;\n    height: 25px;\n}\n}", ""]);

// exports
